import React, {
  useRef,
  useState,
  useEffect,
  RefObject,
  forwardRef,
  useImperativeHandle,
  ForwardRefRenderFunction,
} from 'react';
import {
  Grid,
  Checkbox,
  MenuItem,
  Typography,
  FormControl,
  FormHelperText,
  FormControlLabel,
} from '@mui/material';

import { InstancesCreationCriteriaError } from '../CreateForm';
import Select, { SelectRef } from '../../../../Common/InputComponents/Select';

import { DataSourceAlarmMetadata, AlarmMetadata } from 'types/types';
export interface ConsecutiveValidationRef {
  consecutiveBreach: boolean;
  consecutivePeriod: RefObject<SelectRef | null>;
}

interface ConsecutiveValidationProp {
  alarmMetaData: AlarmMetadata | undefined;
  validationErrors: InstancesCreationCriteriaError;
  alarmDefinitionDataConsecutivePeriod: number | null;
  handleOnChange: (event: string, field: string) => void;
  dataSourceMetadataForAlarm: DataSourceAlarmMetadata | undefined;
}

const ConsecutiveValidation: ForwardRefRenderFunction<
  ConsecutiveValidationRef,
  ConsecutiveValidationProp
> = (
  {
    alarmMetaData,
    handleOnChange,
    validationErrors,
    dataSourceMetadataForAlarm,
    alarmDefinitionDataConsecutivePeriod,
  },
  ref
) => {
  const consecutivePeriodRef = useRef<SelectRef | null>(null);
  const consecutiveValidationRef = useRef<HTMLInputElement | null>(null);
  const [showConsecutiveBreach, setShowConsecutiveBreach] =
    useState<boolean>(false);

  useImperativeHandle(ref, () => ({
    consecutiveBreach: showConsecutiveBreach,
    consecutivePeriod: consecutivePeriodRef,
  }));

  useEffect(() => {
    if (alarmDefinitionDataConsecutivePeriod) {
      setShowConsecutiveBreach(
        alarmDefinitionDataConsecutivePeriod ? true : false
      );
    }
  }, [alarmDefinitionDataConsecutivePeriod]);

  return (
    <div className="consecutive-validation-container">
      <Grid container spacing={2}>
        <Grid item xs={2}>
          <FormControlLabel
            className="rules-checkbox-container"
            control={
              <Checkbox
                inputRef={consecutiveValidationRef}
                disabled={!dataSourceMetadataForAlarm}
                checked={showConsecutiveBreach}
                onChange={() => setShowConsecutiveBreach((prev) => !prev)}
              />
            }
            label="Consecutive Validation"
          />
        </Grid>
        {showConsecutiveBreach && (
          <Grid item xs={2}>
            <Typography className="form-element-label">
              Consecutive Period
            </Typography>
            <FormControl fullWidth error={!!validationErrors.consecutivePeriod}>
              <Select
                size="small"
                className="input-elements"
                inputRef={consecutivePeriodRef}
                value={alarmDefinitionDataConsecutivePeriod ?? ''}
                handleOnChange={(event) =>
                  handleOnChange(event ?? '', 'consecutivePeriod')
                }
                disabled={!dataSourceMetadataForAlarm}
              >
                {alarmMetaData?.consecutivePeriod?.map((s) => (
                  <MenuItem key={`ConsecutivePeriod-${s}`} value={s}>
                    {s}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>
                {validationErrors.consecutivePeriod}
              </FormHelperText>
            </FormControl>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default forwardRef<ConsecutiveValidationRef, ConsecutiveValidationProp>(
  ConsecutiveValidation
);
